import React from "react";
import Image from "next/image";

import shimmer from "./shimmer";

const toBase64 = (str) => (
  typeof window === "undefined"
    ? Buffer.from(str).toString("base64")
    : window.btoa(str)
);

const IMAGE_PLACEHOLDER = "/placeholder.svg";

const LazyImage = (props) => {
  const [src, setSrc] = React.useState(props?.src || IMAGE_PLACEHOLDER);

  const settings = {
    ...props,
    loading: "lazy",
    placeholder: "blur",
    blurDataURL: `data:image/svg+xml;base64,${toBase64(shimmer(props.width, props.height))}`,
    onError: () => setSrc(IMAGE_PLACEHOLDER),
    width: props.width,
    height: props.height,
    src,
  };

  return (
    <Image {...settings} />
  );
};

export default LazyImage;
